import React, { Fragment } from "react";

import img13 from "../../../images/service/Blockchain Development/1.png";
import img14 from "../../../images/service/Blockchain Development/2.png";
import img15 from "../../../images/service/Blockchain Development/3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";


// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Custom Blockchain Development",
    content:
      "We design and develop secure public, private, and hybrid blockchain networks tailored to your business objectives.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Development",
    content:
      "Automate workflows using robust, audited smart contracts that ensure trust, transparency, and efficiency.",
  },
  {
    icon: sIcon3,
    title: "Decentralized Application (dApp) Development",
    content:
      "Build scalable and user-friendly dApps powered by decentralized infrastructure and modern UI frameworks.",
  },
];

const benefits = [
  {
    title: "Transparency & Trust",
    description:
      "Immutable blockchain ledgers ensure transparent transactions and verifiable records across networks.",
    icon: sIcon1,
  },
  {
    title: "Enhanced Security",
    description:
      "Decentralized systems eliminate single points of failure and protect sensitive business data.",
    icon: sIcon2,
  },
  {
    title: "Process Automation",
    description:
      "Smart contracts automate business operations, reducing costs and manual intervention.",
    icon: sIcon3,
  },
  {
    title: "Scalable Architecture",
    description:
      "Our blockchain solutions are designed to scale seamlessly with growing business demands.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is blockchain development?",
    a: "Blockchain development enables businesses to build secure, decentralized, and transparent digital solutions powered by distributed ledger technology. It removes intermediaries, ensures data integrity, and creates trust across digital ecosystems.From smart contracts and dApps to enterprise and Web3 platforms, blockchain solutions help organizations streamline operations, enhance security, and scale with confidence. A well-implemented blockchain strategy drives long-term innovation, efficiency, and market credibility.",
  },
  {
    q: "Which industries use blockchain solutions?",
    a: "Blockchain is widely used in finance, supply chain, healthcare, education, logistics, insurance, and digital identity management.",
  },
  {
    q: "Do you develop private and enterprise blockchains?",
    a: "Yes, we develop private, consortium, and enterprise-grade blockchain networks based on your use case.",
  },
  {
    q: "Can blockchain integrate with existing systems?",
    a: "Absolutely. We ensure seamless integration of blockchain solutions with your current enterprise applications.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function BlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Blockchain Development"
        pagesub="Secure, scalable & enterprise-ready blockchain solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Future-Ready{" "}
            <span className="gradient-text">Blockchain Solutions</span>
          </>
        }
        subtitle={`Transform your business with secure, decentralized blockchain development services.
From custom blockchain platforms to enterprise dApps, we deliver solutions built for trust, scalability, and performance.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Blockchain Development"
      />

      {/* SHORT THEORY */}
      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Blockchain Development?"
        image={img14}
        paragraphs={[
          "Blockchain development enables businesses to build secure, decentralized, and transparent digital solutions powered by distributed ledger technology. It removes intermediaries, ensures data integrity, and creates trust across digital ecosystems.",
          "From smart contracts and dApps to enterprise and Web3 platforms, blockchain solutions help organizations streamline operations, enhance security, and scale with confidence. A well-implemented blockchain strategy drives long-term innovation, efficiency, and market credibility.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Blockchain Development Services"
        cards={serviceCards}
      />

      <TheorySection
        title="Why Blockchain Matters for Enterprise Growth"
        image={img15}
        paragraphs={[
          "Blockchain enables enterprises to build secure, transparent, and tamper-resistant systems that improve operational efficiency and trust across complex business networks. By decentralizing data management and automating workflows through smart contracts, organizations can reduce costs, eliminate manual dependencies, and improve process accuracy.",
          "For enterprises, blockchain adoption is a strategic investment—not just a technology upgrade. It strengthens data integrity, enhances compliance, and supports scalable digital transformation across supply chains, finance, identity management, and enterprise collaboration. A well-architected blockchain solution drives long-term resilience, efficiency, and competitive advantage.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain Development"
        benefits={benefits}
      />


      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Blockchain Solutions"
        subtitle="Built with performance, security, and scalability at the core."
        features={[
          {
            icon: sIcon1,
            title: "Decentralized Architecture",
            description:
              "Eliminate intermediaries and build trustless ecosystems.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract Automation",
            description:
              "Automate complex business logic with transparent execution.",
          },
          {
            icon: sIcon3,
            title: "Enterprise Security",
            description:
              "Advanced cryptographic mechanisms ensure data integrity.",
          },
          {
            icon: sIcon4,
            title: "Scalable Infrastructure",
            description:
              "Designed to handle high transaction volumes efficiently.",
          },
          {
            icon: sIcon5,
            title: "Interoperability",
            description:
              "Seamless integration with existing systems and platforms.",
          },
          {
            icon: sIcon6,
            title: "Ongoing Support",
            description:
              "Continuous monitoring, upgrades, and optimization.",
          },
        ]}
      />
      <Industries/>

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Experienced blockchain architects",
          "Industry-specific blockchain solutions",
          "End-to-end development support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
